export default __webpack_public_path__ + "static/media/File No. 14.4427dd54.pdf";